import { featureFlagClient } from './core/featureFlagClient';
import type { BooleanFlagDetails, FeatureFlagProvider } from './core/featureFlagClient.types';
import type { FeatureFlagKey, PortalFeatureFlagDefinition } from './featureFlagDefinition';

type BooleanPortalFeatureFlagDefinition = PortalFeatureFlagDefinition<
  FeatureFlagKey,
  FeatureFlagProvider,
  'boolean'
>;

export type BooleanFeatureFlagResolution =
  | { status: 'pending' }
  | { status: 'resolved'; value: boolean };

export function getFeatureFlagBooleanDetails(
  definition: BooleanPortalFeatureFlagDefinition,
  defaultValue: boolean
): BooleanFlagDetails {
  return featureFlagClient.getBooleanDetails(definition.key, defaultValue, {
    provider: definition.provider,
  });
}

/**
 * Pending only while the provider is not ready. `FLAG_NOT_FOUND` resolves to
 * `true` (safe default). Other evaluation errors stay pending. Explicit on/off
 * treatments resolve to their returned value.
 */
export function resolveBooleanFeatureFlag(
  details: BooleanFlagDetails,
  isReady: boolean
): BooleanFeatureFlagResolution {
  if (!isReady) {
    return { status: 'pending' };
  }
  if (details.errorCode === 'FLAG_NOT_FOUND') {
    return { status: 'resolved', value: true };
  }
  if (details.errorCode != null) {
    return { status: 'pending' };
  }
  return { status: 'resolved', value: details.value };
}
